import { gql } from 'react-apollo';

export const deactivateEvangelist = gql`
  mutation deactivateEvangelist($input: DeactivateEvangelistInput!) {
    deactivateEvangelist(input: $input) {
      user {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/mutations/deactivateEvangelist.js